import "moment/locale/en-gb";
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/es";

import { ConfigProvider } from "antd";
import de from "antd/es/locale/de_DE";
import enGB from "antd/es/locale/en_GB";
import enUS from "antd/es/locale/en_US";
import es from "antd/es/locale/es_ES";
import it from "antd/es/locale/it_IT";
import moment from "moment";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

import { FALLBACK_LANGUAGE, languages } from "../../i18n";

const antLanguages = {
  [languages.de.key]: de,
  [languages.es.key]: es,
  [languages["en-GB"].key]: enGB,
  [languages["en-US"].key]: enUS,
  [languages.it.key]: it,
};

// set manually set translated formats into ant components
// use LL formats for moment

const LocaleHandler = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const newLanguage = Object.keys(languages).includes(lang) ? lang : FALLBACK_LANGUAGE;

    moment.locale(newLanguage);

    i18n.changeLanguage(newLanguage).then(() => {
      let newLocation = location.pathname.split("/");
      newLocation[1] = newLanguage;
      const nextPathname = newLocation.join("/");

      if (nextPathname !== location.pathname) {
        navigate(`${nextPathname}${location.search}${location.hash}`, { replace: true });
      }
    });
  }, [i18n, lang, location.hash, location.pathname, location.search, navigate]);

  return (
    <ConfigProvider locale={antLanguages[Object.keys(languages).includes(lang) ? lang : FALLBACK_LANGUAGE]}>
      <Outlet />
    </ConfigProvider>
  );
};

export default LocaleHandler;
